import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import './index.css';
import './semantic/dist/semantic.min.css';
import App from './App';
import registerServiceWorker, {unregister} from './registerServiceWorker';

ReactDOM.render(
    <Router>
        <App/>
    </Router>,
    document.getElementById('root'));
// registerServiceWorker();
unregister();
